import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    title: 'Travel Rule',
    description: "We're required by law to gather this information",
    birthDetails: 'Birth Details',
    address: 'Home Address',
    requiredConfirmation: 'Confirmation is required',
    next: 'Next',
    cityOfBirth: 'City of Birth',
    countryOfBirth: 'Country of Birth',
    residencyCity: 'City',
    residencyCountry: 'Country',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    postalCode: 'Post Code',
    confirmation: 'I confirm that I am a legal resident at this address.',
  },
  de: {
    title: 'Travel Rule',
    description:
      'Wir sind gesetzlich verpflichtet, diese Informationen zu sammeln',
    birthDetails: 'Geburtsdaten',
    address: 'Wohnadresse',
    requiredConfirmation: 'Bestätigung ist erforderlich',
    next: 'Weiter',
    cityOfBirth: 'Geburtsstadt',
    countryOfBirth: 'Geburtsland',
    residencyCity: 'Stadt',
    residencyCountry: 'Land',
    addressLine1: 'Adresszeile 1',
    addressLine2: 'Adresszeile 2',
    postalCode: 'Postleitzahl',
    confirmation:
      'Ich bestätige, dass ich an dieser Adresse rechtmäßig wohnhaft bin.',
  },
});
